import React from 'react';
import './Faq.scss';
import IconParticles from '../icon-particles/IconParticles';

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedItems: new Set()
    };
  }

  toggleExpanded = (itemId) => {
    const { expandedItems } = this.state;
    const newExpandedItems = new Set(expandedItems);

    if (newExpandedItems.has(itemId)) {
      newExpandedItems.delete(itemId);
    } else {
      newExpandedItems.add(itemId);
    }

    this.setState({ expandedItems: newExpandedItems });
  };

  renderQuestionItem = (question, answer, number) => {
    const { expandedItems } = this.state;
    const itemId = `faq-${number}`;
    const isExpanded = expandedItems.has(itemId);

    return (
      <article
        key={number}
        className={`QuestionItem ${isExpanded ? 'expanded' : ''}`}
        role="button"
        tabIndex={0}
        aria-expanded={isExpanded}
        onClick={() => this.toggleExpanded(itemId)}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleExpanded(itemId);
          }
        }}
      >
        <section className="QuestionItem__icon" aria-hidden="true">
          <div className="QuestionItem__icon-wrapper">
            <div className="QuestionItem__background-layer" />
            <div className="QuestionItem__number">
              {number.toString().padStart(2, '0')}
            </div>
          </div>
        </section>
        <section className="QuestionItem--right">
          <h3 className="QuestionItem__question">
            {question}
          </h3>
          <div
            className="QuestionItem__answer"
            dangerouslySetInnerHTML={{ __html: answer }}
          />
        </section>
      </article>
    );
  };

  render() {
    const faqData = [
      {
        question: "What is Noiz?",
        answer: "Noiz is a platform for streamers and creators to find opportunities like paid sponsorships, early access to games, commission on sales and much more. We started as a team of gamers for gamers, and are advocates for the creator community!"
      },
      {
        question: "What type of Quests are available?",
        answer: "We aim to have Quests available where you will have opportunities to earn money, early access, free game offers and more."
      },
      {
        question: "How do I know if I'm eligible for a Quest?",
        answer: "On the Quest details, we will show the qualifications and requirements of the Quest. When you try to join a Quest, our platform will also verify you meet the requirements."
      },
      {
        question: "Can I join multiple Quests?",
        answer: "Yes, while some Quests may overlap, you are welcome to join as many Quests as you like. Be aware, we do keep track and if you consistently join Quests but do not fulfill the requirements, you may be banned from future Quests."
      },
      {
        question: "What happens after I join a Quest?",
        answer: "After you have joined a Quest, you will receive an email notification when it goes live and ends."
      },
      {
        question: "Where do I find the Quest details after I join?",
        answer: "Once you are signed up for a Quest, you have two options to find your Quest if you're logged in 1. You can go back and find the Quest details in your Quest Book or 2. In the dropdown menu under your username and in My Quests."
      },
      {
        question: "The Quest tracking started, now what?",
        answer: "Start streaming! Make sure you follow all the requirements in directions in your Quest."
      },
      {
        question: "How do I stream for a game I do not own?",
        answer: "While some Quests require you to already have the game, others will offer a game key as well. Before a Quest goes live, we will send you a notification stating the game key is ready to redeem. When you receive the notification, come back to noiz and in the Quest book, you will be able to find your game key."
      },
      {
        question: "Can I stream longer to make more money?",
        answer: "Quests have certain time limits and while you are welcome to stream longer, for paid Quests, you will only be paid for the live duration."
      },
      {
        question: "Something came up, can I leave a Quest?",
        answer: "To leave a Quest, go to your Quest book located on the top of the site once logged in. Select the Quest and click on the leave Quest button. If you leave a Quest when live, you will lose all progress you have made and forfeit any gains you made."
      },
      {
        question: "How do I get paid?",
        answer: "We use Paypal, if you do not have a Paypal account, please make one."
      },
      {
        question: "When do I get paid?",
        answer: "Payment terms will be different for each Quest, but typically payment occur 45-60 days after the Quest ends depending on the campaign."
      },
      {
        question: "Do I need to follow all the requirements in the Quest?",
        answer: "Yes, we require you to follow all the requirements in the Quest. If we find out at any point you do not have the proper information, you may not qualify for the payouts."
      },
      {
        question: "Why can't I join a Quest?",
        answer: "Sometimes, Quests are invites only while some are based on requirements. You may not be part of a group that has been invited or do not meet the requirements."
      },
      {
        question: "How do you know I completed a Quest?",
        answer: "Our platform verifies your stream times and tags, we may also verify you completed Quest by viewing your video upload."
      },
      {
        question: "How do you determine my pay rate?",
        answer: "Pay rates will differ by Quests. Some may be based on average viewers, sometimes a flat rate. Rates will be displayed on the Quest details."
      },
      {
        question: "What is a Quest Book?",
        answer: "The Quest Book is your history of all the Quests you have participated in or have signed up for. This is also where you will need to go to retrieve game keys when available."
      },
      {
        question: "How do I connect my Twitch Account?",
        answer: "Click on your name and go to connect accounts, there you will see the connections available."
      },
      {
        question: "I'm in a different Time Zone, when do I need to stream?",
        answer: "Noiz works in Pacfic Time zone. Check the start time in your Quest and convert to your time zone from PST."
      },
      {
        question: "I completed my stream, it says failed what do I do?",
        answer: "If you did not complete your stream in the Quest tracking time, you will fail the Quest. You also need to follow the requirements to complete the Quest. Reach out to support if you have issues."
      },
      {
        question: "I completed my stream, how do I see how much / when I will be paid?",
        answer: "Go to your My Quests or Quest Book and you will see the payout and payout date. By default, payments will occur 45-60 days after the Quest has ended."
      },
      {
        question: "How to get my unique referral link?",
        answer: "Your unique referral link will be in the referral Quest. You must have signed up to receive this unique link."
      },
      {
        question: "A Quest is showing me a lower payout than normal, why is this?",
        answer: "The higher tiers spots are full and you can only sign up for this tier."
      },
      {
        question: "I have issues, how can I reach you?",
        answer: 'You can send us any Questions to <a href="mailto:support@noiz.gg">support@noiz.gg</a> or join our Discord channel: <a href="https://discord.gg/4nNpS3kdtp" target="_blank" rel="noopener noreferrer">https://discord.gg/4nNpS3kdtp</a>'
      }
    ];

    return (
      <main className="Faq">
        <div className="Faq__container">
          <section className="Hero" aria-label="FAQ Hero Section">
            <IconParticles />
          </section>
          <section className="Questions" aria-label="Frequently Asked Questions">

            <div className="Questions__content">
              <div className='title_wrap'>
                <span className='Questions__content__title'>Frequently Asked Questions</span>
              </div>
              <div className="QuestionsContainer" role="list">
                {faqData.map((item, index) =>
                  this.renderQuestionItem(item.question, item.answer, index + 1)
                )}
              </div>
            </div>
          </section>
        </div>
      </main>
    );
  }
}

export default FAQ;
